import { useState } from 'react';
import faqs from '../../../../content/FAQ';
import FaqAccordion from './FaqAccordion';

export type FaqType = {
    question: string;
    answer: string;
};

const Faq: React.FC = () => {
    const [selectedAccordion, setSelectedAccordion] = useState<number | null>(null);

    const toggle = (index: number) => {
        setSelectedAccordion((prev) => (prev === index ? null : index));
    };

    return (
        <section id='faq'>
            <div className='container'>
                <div className='inner__left'>
                    <h2>Question & Answers</h2>
                </div>
                <div className='inner__right'>
                    {faqs.map((faq: FaqType, index: number) => (
                        <FaqAccordion
                            key={index}
                            faq={faq}
                            collapsed={selectedAccordion === index}
                            toggle={() => toggle(index)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Faq;
